export const LOAD_MORE_SET_PRODUCTS = "LOAD_MORE_SET_PRODUCTS";

export const setCurrentProductsCount = (currentProductCount) => ({
    type: LOAD_MORE_SET_PRODUCTS,
    payload: {
        currentProductCount
    }
})

export const setTotalProducts = (totalProducts) => ({
    type: LOAD_MORE_SET_PRODUCTS,
    payload: {
        totalProducts
    }
})